import React from "react";
import { Stack } from "@mui/material";
import OwnerClientActivityPanel from "./OwnerClientActivityPanel";
import OwnerClientCommercialPanel from "./OwnerClientCommercialPanel";
import OwnerClientIdentityCard from "./OwnerClientIdentityCard";
import OwnerClientCrmJourneyPanel from "./OwnerClientCrmJourneyPanel";
import OwnerClientProjectsPanel from "./OwnerClientProjectsPanel";
import OwnerClientWebProfitPanel from "./OwnerClientWebProfitPanel";

function projectUnion(context) {
  const rows = [
    ...(context?.projects || []).map((row) => ({ ...row, ownerClientLink: "linked" })),
    ...(context?.detectedProjects || []).map((row) => ({ ...row, ownerClientLink: "detected" })),
  ];
  const seen = new Set();
  return rows.filter((row) => {
    const id = String(row?.id || row?._id || "");
    if (!id || seen.has(id)) return false;
    seen.add(id);
    return true;
  });
}

export default function OwnerClientPlatformDetail({
  client,
  platformContext,
  crmContext,
  loadingCrm,
  loadingPlatform,
  crmError,
  platformError,
  onLinkUser,
  onRefreshCrm,
  onRefreshPlatform,
  onClientUpdated,
  onPlatformContextUpdated,
  identityEditToken = "",
}) {
  const platformProjects = projectUnion(platformContext);

  return (
    <Stack spacing={1.4}>
      <OwnerClientIdentityCard client={client} onClientUpdated={onClientUpdated} autoEditKey={identityEditToken} />
      <OwnerClientCrmJourneyPanel client={client} onClientUpdated={onClientUpdated} onRefresh={onRefreshCrm} />
      <OwnerClientProjectsPanel client={client} context={crmContext} loading={loadingCrm} error={crmError} onRefresh={onRefreshCrm} />
      <OwnerClientActivityPanel
        client={client}
        context={crmContext}
        loading={loadingCrm}
        error={crmError}
        platformProjects={platformProjects}
        onRefresh={onRefreshCrm}
      />
      <OwnerClientCommercialPanel context={crmContext} platformProjects={platformProjects} />
      <OwnerClientWebProfitPanel
        client={client}
        context={platformContext}
        loading={loadingPlatform}
        error={platformError}
        onLinkUser={onLinkUser}
        onContextUpdated={onPlatformContextUpdated}
        onRetry={onRefreshPlatform}
      />
    </Stack>
  );
}
